import "../../style/fastShipment/FastShipmentPrice.css";
import { Modal, Button } from "@mui/material";
import { useCallback, useMemo } from "react";
import FastShipmentPrices from "./fastShipmentPriceModal/FastShipmentPrices";
import { useRecoilState } from "recoil";
import { fastListState } from "../../atoms/fastShipment";
import { shouldHideSupplier, hasPermissionType1Or2 } from "../../utils/SpecialUserIds";

const FastShipmentPriceModal = ({
  status,
  setStatus,
  items,
  setSelectedPriceObject,
  setPriceID,
  setPriceIDValue,
  dataID,
  insuranceFast,
  setInsuranceFast,
  ddpFast,
  setDdpFast,
  lucidFast,
  setLucidFast,
  isAbove150EURCheck,
  setIsAbove150EURCheck,
  selectedFastShipmentProduct
}) => {
  // const sortedItems = [...item?.prices?.data]?.sort((a, b) => a?.selling_price - b?.selling_price);

  const [fastList, setFastList] = useRecoilState(fastListState);

  // Filter suppliers: if 1342 is cheaper than 1350, show only 1342; if 1350 is cheaper, show both
  // YETKİLİ (permission 1 veya 2): 342, 343, 348, 350 görünür - 1342, 1343, 1348, 1350 gizli
  // YETKİSİZ: 1342, 1343, 1348, 1350 görünür - 342, 343, 348, 350 gizli
  const filteredPrices = useMemo(() => {
    const pricesData = items?.prices?.data || [];
    let tempArray = [...pricesData];

    // Yetki bazlı filtreleme (348 ve 1348 hariç, onlar aşağıda özel olarak ele alınır)
    tempArray = tempArray.filter((x) => {
      const id = Number(x?.supplier_id);
      if (id === 348 || id === 1348) return true;
      return !shouldHideSupplier(id);
    });

    // 348 ve 1348 özel mantığı
    // ABD + izin VAR → 348 göster, 1348 gizle
    // ABD + izin YOK → 1348 göster, 348 gizle
    // ABD dışı → 348 göster, 1348 gizle
    const isUSArrival = (() => {
      const val = String(items?.country || "").trim().toLowerCase();
      const synonyms = new Set(["us", "usa", "abd", "amerika", "amerika birleşik devletleri", "united states", "united states of america"]);
      return synonyms.has(val);
    })();
    const hasPermission = hasPermissionType1Or2();

    tempArray = tempArray.filter((x) => {
      const id = Number(x?.supplier_id);
      if (id === 348) return !isUSArrival || hasPermission;
      if (id === 1348) return isUSArrival && !hasPermission;
      return true;
    });

    // Filter for 1342 and 1350 and 1348
    const supplier1342 = tempArray?.find((x) => x?.supplier_id === 1342);
    const supplier1350 = tempArray?.find((x) => x?.supplier_id === 1350);

    if (supplier1342 && supplier1350) {
      const price1342 = (supplier1342?.selling_price ?? 0) * (supplier1342?.exchange_rate ?? 1);
      const price1350 = (supplier1350?.selling_price ?? 0) * (supplier1350?.exchange_rate ?? 1);

      // If 1342 is cheaper, show only 1342; if 1350 is cheaper or equal, show both
      if (price1342 < price1350) {
        tempArray = tempArray.filter((x) => x?.supplier_id !== 1350);
      }
    }

    return tempArray;
  }, [items?.prices?.data, items?.country]);

  const handleCloseReset = useCallback(() => {
    // Modal kapandığında (dışına tıklama veya Kapat) ilgili kaydın isPriceTake değerini "0" yap
    if (dataID) {
      setFastList((prevList) =>
        prevList.map((fast) =>
          fast.id === dataID
            ? {
              ...fast,
              isPriceTake: "0",
            }
            : fast
        )
      );
    }
    setStatus(false);
  }, [dataID, setFastList, setStatus]);

  const handleCloseNoReset = useCallback(() => {
    // Fiyat seçildiğinde sadece modal kapansın, isPriceTake korunur
    setStatus(false);
  }, [setStatus]);

  const member = JSON.parse(localStorage.getItem("user"));
  const memberId = member?.user?.user_member?.id;

  return (
    <Modal open={status} onClose={handleCloseReset} className="get-card-modal">
      <div
        className="get-card-container"
        style={{
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <div className="get-card-wrapper">
          {filteredPrices?.map((item, key) => (
            <FastShipmentPrices
              key={key}
              item={item}
              items={items}
              setSelectedPriceObject={setSelectedPriceObject}
              handleClose={handleCloseNoReset}
              setPriceID={setPriceID}
              setPriceIDValue={setPriceIDValue}
              dataID={dataID}
              insuranceFast={insuranceFast}
              setInsuranceFast={setInsuranceFast}
              ddpFast={ddpFast}
              setDdpFast={setDdpFast}
              lucidFast={lucidFast}
              setLucidFast={setLucidFast}
              isAbove150EURCheck={isAbove150EURCheck}
              setIsAbove150EURCheck={setIsAbove150EURCheck}
              selectedFastShipmentProduct={selectedFastShipmentProduct}
            />
          ))}
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
          <Button className="iyzi-button-blue" onClick={handleCloseReset}>
            Kapat
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default FastShipmentPriceModal;
